import { render, staticRenderFns } from "./ProductProcess.vue?vue&type=template&id=dc48d74e&scoped=true&"
import script from "./ProductProcess.vue?vue&type=script&lang=js&"
export * from "./ProductProcess.vue?vue&type=script&lang=js&"
import style0 from "./ProductProcess.vue?vue&type=style&index=0&id=dc48d74e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc48d74e",
  null
  
)

export default component.exports